module.exports = __webpack_public_path__ + "img/ky-syt.1c561221.png";